import dayjs from 'dayjs';
import { useStore } from 'vuex';

import { EMAIL } from '@/constants/subscriptions';
import { mindboxGtmEvents } from '@/gtm/mindbox-gtm-events';
import { getCookie, removeCookie, setCookie } from '@/utils/cookies/mindbox-auth-cookies';

type TUseMindboxAnalytics = () => {
  sendEvent(): void
  removeCookie(): void
};

type TEventParams = {
  email: string,
  mobilePhone: string,
  firstName: string,
  emailSubscription: boolean,
  accountId: string,
};

function getMaxAge(): number {
  return dayjs(dayjs().endOf('day').diff(dayjs())).unix();
}

export const useMindboxAnalytics: TUseMindboxAnalytics = () => {
  const store = useStore();

  function getParams(): TEventParams {
    const {
      id,
      email,
      phone,
      firstName,
    } = store.getters['user/account'];
    const subscriptions = store.getters['user/subscriptions'];

    const hasEmailSubscription = subscriptions.some(({
      active, code,
    }: { active: boolean, code: string }) => code === EMAIL && active);

    return {
      email,
      mobilePhone: phone,
      firstName,
      emailSubscription: hasEmailSubscription,
      accountId: id,
    };
  }

  function sendEvent() {
    const loggedIn = store.getters['user/loggedIn'];
    const hasCookie = getCookie();

    if (loggedIn && !hasCookie) {
      setCookie(getMaxAge());
      mindboxGtmEvents.onAuth(getParams());
    }
  }

  return {
    sendEvent,
    removeCookie,
  };
};
